import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Http } from '@angular/http';
import { map } from 'rxjs/operators';
import { UtilsService } from './../_services/utils.service';

@Injectable()
export class TournamentService {
  constructor(private http: Http, private _utilsService: UtilsService) {
  }

  getTournamentData(tournament_id, league_id, user_id, tab_name, page_no,keyword): Observable<any> {
    const access_token = `${environment.DRAFT_ACCESS_TOKEN}`;
    let URL = '';
    if (tab_name === 'entrants') {
      URL = `${environment.phpApiUrl}` + '/tournament/infoBox/' + access_token + '/' + tournament_id + '/' + league_id + '/' + user_id + '/' + tab_name + '?page=' + page_no+'&keyword='+keyword;
    } else {
      URL = `${environment.phpApiUrl}` + '/tournament/infoBox/' + access_token + '/' + tournament_id + '/' + league_id + '/' + user_id + '/' + tab_name;
    }
    return this._utilsService.getRequest(URL);
  }

  getDraftPopupData(league_id, user_id, tab_name): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/infoBox/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_id + '/' + user_id + '/' + tab_name);
  }

  getJoinPopUpData(requestData): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/draftjoin/joinConfirm/', requestData);
  }
  
  getUserLocation(user_id, callback) {
    let has_location = this._utilsService.hasUserLocation();
    if (has_location) {
      let res = this._utilsService.getUserLocation();
      callback(res);
    }
    else {
      this._utilsService.setUserLocation(`${environment.phpApiUrl}` + '/user/getLocation/' + `${environment.DRAFT_ACCESS_TOKEN}`+ '/' + user_id, function(res){
        callback(res);  
      });
    }
  }
  
  modifyUserLocation(data) {
    return this._utilsService.modifyUserLocation(data);
  } 

  joinLeague(data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/draftjoin/join-league/', data);
  }

  joinMultiEntry(data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/league/multi-enter-draft/', data);
  }

  leaveLeagueRequest(league_code, user_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/draft/leave-league/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_code + '/' + user_id);
  }

  getIpAddress(user_id:any): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/getLocation/' + `${environment.DRAFT_ACCESS_TOKEN}`+ '/' + user_id +'?is_ip_address=1');
  }

  geLocationData(longitude, latitude): Observable<any> {
    const URL = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&sensor=true&key=AIzaSyArDMsepOf9RkvysNLb6aVKmbo6qtis9m8`;
    return this.http
      .get(URL)
      .pipe(
        map(res => res.json())
      );
  }

  saveLocationData(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.SITE_URL}` + '/user/save-location-data', data);
  }
  
  draftLeaveLeagueRequest(requestData): Observable<any> {
    requestData['access_token'] = `${environment.DRAFT_ACCESS_TOKEN}`;
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/draftleave/leave-league', requestData);
  }

  getMiletoneDetails(tournamentId) {
    return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/api/front/getMilestonBonusDetails/' + tournamentId);
  }
}